const licenses = {
  individual: [
    "Report accessible by 1 user only",
    "Free 15% or 32 hours of customisation",
    "Free post-sale service assistance",
    "Direct access to lead analysts",
    "Report delivery on Compass (our interactive cloud platform)"
  ],
  team: [
    "Report accessible by up to 5 users",
    "Free 25% or 54 hours of customisation",
    "Free access to report summaries",
    "Direct access to lead analysts",
    "25% discount on your next purchase",
    "Report delivery on Compass (our interactive cloud platform)",
    "Service guarantee available (Full/partial refund in case of quality concerns)",
    "Dedicated account manager",
    "Personalised market brief by the lead author",
    "Permission to print the report"
  ],
  enterprise: [
    "All team license features plus",
    "Free 30% or 64 hours of customisation",
    "Unlimited user access (Within your organization)",
    "Exclusive previews of upcoming research & latest releases",
    "30% discount on your next purchase",
    "Customisable dashboards on Compass"
  ]
};

export default licenses;